import React from "react";

const JQuery_Set = () => {
  return (
    <div>
      <h1>JQuery_Set</h1>
      <p>Placeholder component for: "JQuery_Set"</p>
    </div>
  );
};

export default JQuery_Set;
